export const Version = {
	version: '3.19.0.34'
};
